'use strict';

var parseGooglePlace = require('./googleAutoComplete/parseGooglePlace');

var $autoCompleteInputFields = $('.google-autocomplete');

/**
 * function to fill the address form fields
 * @param {string} $addressContainer - Container component for all address fields
 * @param {string} address - address object returned by google
 * @param {string} isStreetOrderReverse - Order of street name and Street number.street name + Street number is considered by default.
 */
function fillInAddress($addressContainer, address, isStreetOrderReverse) {
    // Setting address value or defaulting to blank.
    if (address) {
        // Updating Address line 1
        var $addressLine1El = $addressContainer.find('[name$=_address1]');
        if (isStreetOrderReverse) {
            $addressLine1El.val(address.streetName + ' ' + address.streetNumber);
        } else if (address.streetNumber && address.streetName) {
            $addressLine1El.val(address.streetNumber + ' ' + address.streetName);
        } else if (address.streetNumber && !address.streetName) {
            $addressLine1El.val(address.streetNumber);
        } else if (!address.streetNumber && address.streetName) {
            $addressLine1El.val(address.streetName);
        }
        $addressLine1El.trigger('keyup');

        // Updating Country
        var $countryEl = $addressContainer.find('[name$=_country]');
        if ($countryEl.is('select')) {
            var countryOptions = $countryEl[0].options;
            var $countryOption;
            for (var i = 0; i < countryOptions.length; i++) {
                $countryOption = $(countryOptions[i]);
                if (address.countryShort.indexOf($countryOption.attr('value')) !== -1) {
                    $countryOption.prop('selected', true);
                }
            }
        } else {
            $countryEl.val(address.countryShort || '');
        }
        $countryEl.trigger('keyup');

        // Updating State
        var $stateEl = $addressContainer.find('[name$=_states_stateCode]');
        if ($stateEl.is('select')) {
            var stateOptions = $stateEl[0].options;
            var $stateOption;
            for (var j = 0; j < stateOptions.length; j++) {
                $stateOption = $(stateOptions[j]);
                if (address.stateShort.indexOf($stateOption.attr('value')) !== -1) {
                    $stateOption.prop('selected', true);
                }
            }
        } else {
            $stateEl.val(address.stateShort || '');
        }
        $stateEl.trigger('keyup');
        $stateEl.trigger('change');

        // Updating City
        var $cityEl = $addressContainer.find('[name$=_city]');
        $cityEl.val(address.city || '');
        $cityEl.trigger('keyup');

        // Updating ZipCode
        var $zipCodeEl = $addressContainer.find('[name$=_postalCode]');
        $zipCodeEl.val(address.zipCode || '');
        $zipCodeEl.trigger('keyup');
        $zipCodeEl.trigger('input');

        var $latEl = $addressContainer.find('[name$=_lat]');
        var $lngEl = $addressContainer.find('[name$=_lng]');
        $latEl.val(address.lat);
        $lngEl.val(address.lng);

        var checkoutStep;
        if ($addressContainer.attr('name')) {
            if ($addressContainer.attr('name').indexOf('shipping') >= 0) {
                checkoutStep = 'shipping';
            } else if ($addressContainer.attr('name').indexOf('billing') >= 0) {
                checkoutStep = 'billing';
            }
        }

        setTimeout(function() {
            $('body').trigger('gtmGoogleSuggestion', [checkoutStep, 'google suggestion', $addressLine1El]);
        }, 0);
    }
}

/**
 * Initializes autofill
 */
function initializeAutoComplete() {
    $autoCompleteInputFields.each(function() {
        var autoCompleteInputField = this;
        var $autoCompleteInputField = $(this);

        var $addressForm = $autoCompleteInputField.closest('form');
        var isStreetOrderReverse = $autoCompleteInputField.data('reverse-street-order');

        var defaultOptions = {
            componentRestrictions: {
                country: 'US'
            }
        };

        // Create the autocomplete object
        // eslint-disable-next-line no-undef
        var autoCompleteInstance = new google.maps.places.Autocomplete(autoCompleteInputField, defaultOptions);

        // eslint-disable-next-line no-undef
        google.maps.event.addListener(autoCompleteInstance, 'place_changed', function() {
            var address = parseGooglePlace(autoCompleteInstance.getPlace());

            // When the user selects an address from the dropdown, call the function to fill the address elements
            fillInAddress($addressForm, address, isStreetOrderReverse);
        });

        // eslint-disable-next-line no-undef
        google.maps.event.addDomListener(autoCompleteInputField, 'keydown', function(event) {
            if (event.keyCode === 13) {
                // Preventing form submit when user presses enter key on auto complete field
                event.stopPropagation();
                event.preventDefault();
            }
        });

        $(document).on('custom:change:autocomplete:country', function(e, data) {
            autoCompleteInstance.setComponentRestrictions({
                country: data.countryCode
            });
        });
    });
}

$(document).ready(function() {
    // eslint-disable-next-line no-undef
    if (google) {
        // eslint-disable-next-line no-undef
        google.maps.event.addDomListener(window, 'load', initializeAutoComplete);
    }
});
